import { render, staticRenderFns } from "./products.vue?vue&type=template&id=378981a0&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&id=378981a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378981a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378981a0')) {
      api.createRecord('378981a0', component.options)
    } else {
      api.reload('378981a0', component.options)
    }
    module.hot.accept("./products.vue?vue&type=template&id=378981a0&scoped=true&", function () {
      api.rerender('378981a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/terminal_audit/form/components/products/products.vue"
export default component.exports